module.exports = __webpack_public_path__ + "img/am.6875db7.svg";